import { cn } from '@perch/ui-tokens';

interface StatusDotProps {
  variant?: 'active' | 'inactive';
  className?: string;
}

export function StatusDot({ variant = 'active', className }: StatusDotProps) {
  if (variant === 'inactive') {
    return (
      <span className={cn('relative flex h-2 w-2', className)}>
        <span className="relative inline-flex rounded-full h-2 w-2 bg-stone-300 dark:bg-stone-600" />
      </span>
    );
  }

  return (
    <span className={cn('relative flex h-2 w-2', className)}>
      <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-emerald-400 opacity-75" />
      <span className="relative inline-flex rounded-full h-2 w-2 bg-emerald-500" />
    </span>
  );
}
